@if (record) {
  @switch (layout) {
    @case ("horizontal") {
      <mat-horizontal-stepper #stepper labelPosition="bottom" (selectionChange)='stepChange.emit($event)'>
        <mat-step [completed]='record' [state]="'number'">
          <ng-template matStepLabel>
            {{'Partenze' | translate}}
          </ng-template>
        </mat-step>
        <mat-step [completed]='record' [state]="'number'">
          <ng-template matStepLabel>
            {{'Informazioni Base' | translate}}
          </ng-template>
        </mat-step>
        <mat-step [completed]='record' [state]="'number'">
          <ng-template matStepLabel>
            {{'Partecipanti' | translate}}
          </ng-template>
        </mat-step>
        <mat-step [completed]='record' [state]="'number'">
          <ng-template matStepLabel>
            {{'Sconti' | translate}}
          </ng-template>
        </mat-step>
      </mat-horizontal-stepper>
    }
    @case ("vertical") {
      <fuse-sidebar class="left" name="page-sidebar" position="left" lockedOpen="gt-md">
        <div class="header p-24">
          <h2 class="m-0 title">{{'Prenotazione' | translate}}</h2>
        </div>
        <div class="content">
          <mat-vertical-stepper #stepper linear="!Boolean(record)" (selectionChange)='stepChange.emit($event)'>
            <mat-step [completed]='record' [state]="'number'">
              <ng-template matStepLabel>
                {{'Partenze' | translate}}
              </ng-template>
            </mat-step>
            <mat-step [completed]='record' [state]="'number'">
              <ng-template matStepLabel>
                {{'Informazioni Base' | translate}}
              </ng-template>
            </mat-step>
            <mat-step [completed]='record' [state]="'number'">
              <ng-template matStepLabel>
                @if (record) {
                  <span><!--[{{record.participant_count}}]--></span>
                  } {{'Partecipanti' | translate}}
                </ng-template>
              </mat-step>
              <mat-step [completed]='record' [state]="'number'">
                <ng-template matStepLabel>
                  {{'Sconti' | translate}}
                </ng-template>
              </mat-step>
            </mat-vertical-stepper>
          </div>
        </fuse-sidebar>
      }
      @default {
        No stepper configured!
      }
    }
  }
